import React from 'react'

const ActivitiesHome = () => {
  return (
    <div>ActivitiesHome</div>
  )
}

export default ActivitiesHome